import React, { useState } from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

function CookieConsent() {
  const { t } = useLanguage();
  const { consent, setConsent, showBanner, openSettings, acceptAll, rejectOptional } = useCookieConsent();
  const [showSettings, setShowSettings] = useState(false);
  const [localAnalytics, setLocalAnalytics] = useState(consent.analytics);
  const [localMarketing, setLocalMarketing] = useState(consent.marketing);

  const handleOpenSettings = () => {
    setLocalAnalytics(consent.analytics);
    setLocalMarketing(consent.marketing);
    setShowSettings(true);
    openSettings();
  };

  const handleSaveSettings = () => {
    setConsent({
      necessary: true,
      analytics: localAnalytics,
      marketing: localMarketing,
      timestamp: Date.now(),
    });
    setShowSettings(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-wrap" role="dialog" aria-labelledby="cookie-consent-title" aria-describedby="cookie-consent-desc">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <h2 id="cookie-consent-title" className="cookie-consent-title">
            {t('cookies')}
          </h2>
          <p id="cookie-consent-desc" className="cookie-consent-desc">
            {t('cookieBannerText')} <Link to="/page/cookies" className="cookie-consent-link">{t('cookiePolicyInLink')}</Link>.
          </p>

          {!showSettings ? (
            <div className="cookie-consent-actions">
              <button type="button" className="btn btn-primary cookie-btn" onClick={acceptAll}>
                {t('acceptAll')}
              </button>
              <button type="button" className="btn btn-secondary cookie-btn" onClick={handleOpenSettings}>
                {t('cookieSettingsBtn')}
              </button>
              <button type="button" className="btn btn-secondary cookie-btn" onClick={rejectOptional}>
                {t('rejectOptional')}
              </button>
            </div>
          ) : (
            <div className="cookie-consent-settings">
              <p className="cookie-settings-intro">{t('cookieSettingsIntro')}</p>
              <div className="cookie-settings-list">
                <div className="cookie-setting-item cookie-setting-necessary" role="img" aria-label={t('necessaryCookies')}>
                  <span className="cookie-checkbox-checked" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="cookie-check-svg">
                      <rect className="cookie-check-rect" x="0.5" y="0.5" width="13" height="13" rx="2" />
                      <path className="cookie-check-mark" d="M3 7l3 3 5-6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span>{t('necessaryCookies')}</span>
                </div>
                <label className="cookie-setting-item">
                  <input
                    type="checkbox"
                    checked={localAnalytics}
                    onChange={(e) => setLocalAnalytics(e.target.checked)}
                  />
                  <span>{t('analyticsCookies')}</span>
                </label>
                <label className="cookie-setting-item">
                  <input
                    type="checkbox"
                    checked={localMarketing}
                    onChange={(e) => setLocalMarketing(e.target.checked)}
                  />
                  <span>{t('marketingCookies')}</span>
                </label>
              </div>
              <div className="cookie-consent-actions">
                <button type="button" className="btn btn-primary cookie-btn" onClick={handleSaveSettings}>
                  {t('saveChoice')}
                </button>
                <button type="button" className="btn btn-secondary cookie-btn" onClick={() => setShowSettings(false)}>
                  {t('back')}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
